'use strict';

function resizeWindow() {}

function scrollDown() {}

function fadeContent(btn, content, className) {
    btn.click(function (event) {
        event.preventDefault();
        btn.toggleClass(className);
        content.fadeToggle();
    });
}

function cookies() {

    var COOKIE_NAME = 'nye_cookie',
        $go = $.cookie(COOKIE_NAME);
    if ($go == null) {

        $.cookie(COOKIE_NAME, 'nye-cookie', {
            path: '/',
            expires: 1
        });

        showPopUp();

        console.log("cookie");
        // hideLoad();
    } else {
        console.log("no-cookie");
        hidePopUp();
        // hideLoad();
    }

    showPopUp();

    $('.pop-modal #close-pop').click(function () {

        if ($(this).hasClass("active")) {
            $('.pop-modal').animate({
                right: "-410px"
            }, 300);
        } else {
            $('.pop-modal').animate({
                right: "0px"
            }, 300);
        }

        $(this).toggleClass('active');
    });

    function showPopUp() {
        // $('.pop-modal').animate({
        // 		right: "0px"
        // }, 500 );
        $('.pop-modal').fadeIn();
    }

    function hidePopUp() {
        // $('.pop-modal').animate({
        // 	  right: "-352px"
        // }, 500 );

        $('.pop-modal #close-pop').addClass('active');
        $('.pop-modal').hide();
    }
}

$(function () {

    //landing
    $('.terms-accordion').click(showTerms);

    $('.check-btn').on('click', function (e) {
        $('.booking-widget').animate({ right: "0" }, 500);
    });
    $('.close-btn').on('click', function (e) {
        $('.booking-widget').animate({ right: "-461" }, 500);
    });

    //Call function with browser is resized.
    $(window).resize(function (event) {
        resizeWindow();
    });
    resizeWindow();

    //Acts when scroll down page.
    $(window).scroll(function (event) {
        scrollDown();
        var top = $(document).scrollTop();
        if (top > 100) {
            $('#header .logo-box').addClass('scroll');
        } else {
            $('#header .logo-box').removeClass('scroll');
        }
    });

    // Main Nav Dropdown
    $("#primary-nav li").hover(function () {

        $(this).addClass("hover");
        $('ul.submenu', this).fadeIn(200);
    }, function () {

        $(this).removeClass("hover");
        $('ul.submenu', this).fadeOut(200);
    });

    //Home page scroll down arrow. If present.
    $('.arrow-home').click(function (event) {
        $('body, html').animate({
            scrollTop: $(window).height() - $('header').outerHeight() * 2
        }, 800, 'easeOutExpo');
    });

    $('.open-booking-widget-inline-date').on('click', function (e) {
        $("#adults").val(2);
        $("#child").val(0);
        $("#number_guest").text("2 ADULTS");
    });

    //Event Tracking
    $('.book-now').on('click', function () {
        if (typeof "ga" == "function") ga('send', 'event', 'reservations', 'click', 'book now');
    });
    $('.bookNow').on('click', function () {
        ga('send', 'event', 'header widget', 'click', 'book now');
    });
    $('#email-signup button').on('click', function () {
        ga('send', 'event', 'form', 'form submission', 'specials');
    });

    //Check in and check out datepicker for booking engine
    $(".datepicker").datepicker({
        changeMonth: true,
        numberOfMonths: 1,
        minDate: 0
    });

    $("#CheckIn").datepicker({
        changeMonth: true,
        numberOfMonths: 1,
        onSelect: function onSelect(selectedDate) {
            var getDate = $(this).datepicker('getDate');
            var newDate = new Date(getDate.getTime());
            newDate.setDate(newDate.getDate() + 2);
            $("#CheckOut").datepicker("setDate", newDate);
            $("#CheckOut").datepicker("option", "minDate", selectedDate);
        }
    });
    $("#CheckOut").datepicker({
        changeMonth: true,
        numberOfMonths: 1
        /*onSelect: function( selectedDate ) {
        	$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
        }*/
    });

    //landing page booking datepickers
    $(".landing-checkin.datepickeralt").datepicker({
        changeMonth: true,
        numberOfMonths: 1,
        altField: ".CheckIn--alt",
        onSelect: function onSelect(selectedDate) {
            var getDate = $(this).datepicker('getDate');
            var newDate = new Date(getDate.getTime());
            newDate.setDate(newDate.getDate() + 2);
            $(".landing-checkout").datepicker("setDate", newDate);
            $(".landing-checkout").datepicker("option", "minDate", selectedDate);
        }
    });
    $(".landing-checkout.datepickeralt").datepicker({
        changeMonth: true,
        numberOfMonths: 1,
        altField: ".CheckOut--alt"
    });

    $("#emailSignupGuestFolio").click(function () {
        $.post(site_url + 'ajax/guestfolio.php', $("#email-signup").serialize(), function (data) {
            if (data.error) {
                $("#email-error").html(data.msg);
            } else {

                $('#email-signup').find("input[type=text]").val("");
                $("#email-error").html('Thank you for joining our list to receive exclusive news and offers.');
                $("#email-error").show();
            }
        }, 'json');
    });

    // PRESS TEMPLATE
    showContent($('.media-inquiry-btn'), $('#media-inquiry'), 'active');
    // $('.media-inquiry-btn').click(function(){
    // 	$('#media-inquiry').fadeToggle(); 
    // });
    $('.close-media-form').click(function () {
        $('#media-inquiry').fadeOut();
    });
    $('.login-show').click(function () {
        $('#frmLogin').slideToggle();
    });

    if (document.getElementById('terms_btn')) {
        var btnTerms = document.getElementById('terms_btn');
        var termsInfo = document.getElementById('terms_info');
        var termsInfoHeight = termsInfo.getElementsByClassName('wrap')[0].clientHeight;
        btnTerms.addEventListener('click', function (e) {
            e.preventDefault();
            termsInfo.classList.toggle('open');
            if (!this.classList.contains('active')) {
                this.classList.add('active');
                termsInfo.style.height = termsInfoHeight + 'px';
            } else {
                this.classList.remove('active');
                termsInfo.style.height = '0px';
            }
        });
    }

    // OFFERS TEMPLATE
    $('.read-more').click(function (e) {
        var targetTal = $(this).next('div.special-full').length;
        if (targetTal) {
            targetTal.slideToggle();
            var text = $(this).text();
            $(this).text(text == "Terms & Conditions -" ? "Terms & Conditions +" : "Terms & Conditions -");
        }
    });
    $('.reservation-includes').click(function (e) {
        $(this).toggleClass('active');
        $(this).next('div.reservations-full').slideToggle();
    });

    $('.trigger-btn').click(function (e) {
        e.preventDefault();
        var a = $(this);

        var target = $(this).attr('href');

        $('html, body').animate({
            scrollTop: $(target).offset().top
        }, 800);

        if (a.hasClass('active')) {
            a.removeClass('active');
        } else {
            a.addClass('active');
        }

        $('div.section-hide').slideToggle();
        $('div.section-hide').toggleClass('open');

        if ($('div.section-hide').hasClass('open')) {
            $('.trigger-btn').hide();
        } else {
            $('.trigger-btn').show();
        }
    });

    $('.trigger-close').click(function (e) {
        e.preventDefault();
        $('.trigger-btn').show();
        $('div.section-hide').slideToggle();
        $('div.section-hide').toggleClass('open');
    });

    // Map: Return to previous page button. Change body id to match map template's name.
    //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
});

function showTerms() {
    $('.terms-content').slideDown();
    $(this).addClass('open');
    $(this).unbind('click');
    $(this).click(hideTerms);
}

function hideTerms() {
    $('.terms-content').slideUp();
    $(this).removeClass('open');
    $(this).unbind('click');
    $(this).click(showTerms);
}

$(window).on('load', function () {

    function _get_form_token() {
        $.get(site_url + '/ajax/functions.php?operation=_get_form_token', function (resp) {
            $("input[name=_token][type=hidden]").each(function () {
                this.value = resp;
            });
        });
    }
    $(function () {
        _get_form_token();
    });

    /**Special other offers */
    $('.other-specials-slider').slick({
        arrows: false,
        dots: false,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 500,
        fade: false,
        accessibility: false,
        pauseOnHover: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 4000

            }
        }, {
            breakpoint: 1026,
            settings: {
                slidesToShow: 2,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 4000
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 4000
            }
        }]
    });

    //Slick Slider
    $('.sym-slides').slick();

    $('.separate-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.separate-nav',
        accessibility: false,
        draggable: false
    });
    $('.separate-nav').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.separate-for',
        dots: true,
        focusOnSelect: true,
        accessibility: true,
        arrows: false
    });

    equalize();

    //Open / Close Booking
    fadeContent($('.book-trigger'), $('.booking-widget'), 'book-close');

    //Full menu show
    menu($('#header .main-menu .burger'));
    $('#map #footer').prepend('<a href="javascript:history.go(-1)" class="btn previous-page">Previous Page</a>');

    // Vertical Tablet - Help Media Query
    if ($(window).width() < 992) {
        var htmlString = '<a href="/olde-pink-house-restaurant">Olde Pink House</a>';
        $("#secondary-nav li").first().html(htmlString);
    }

    cookies();
});

var inputCheckIn = document.getElementById('CheckIn');
var inputCheckOut = document.getElementById('CheckOut');

if (inputCheckIn && inputCheckOut) {
    inputCheckIn.setAttribute('aria-label', 'enter your arrival date');
    inputCheckOut.setAttribute('aria-label', 'enter your departure date');
}